/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetUserTypes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserTypesRequest = createAction<PayloadData<void>>('GET_USER_TYPES__GET_USER_TYPES__REQUEST');
export const getUserTypesSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_USER_TYPES__GET_USER_TYPES__SUCCESS');
export const getUserTypesFailure = createAction<PayloadData<Error, void, true>>('GET_USER_TYPES__GET_USER_TYPES__FAILURE');

export const getUserTypesActions = [
    getUserTypesRequest,
    getUserTypesSuccess,
    getUserTypesFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserTypes = (config?: GetUserTypes$Config) => {
    return {
        CALL_API: {
            types: getUserTypesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/user-type`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

